import type { BrowserCacheResourceConfig } from '../controllers/browserCacheController/types';

export const CoreResources: BrowserCacheResourceConfig = {
  /* fonts */
  REGULAR: { url: './assets/fonts/Poppins-Regular.woff2', priority: 'block', kind: 'font' } /* core default regular */,
  BOLD: { url: './assets/fonts/Poppins-SemiBold.woff2', priority: 'block', kind: 'font' } /* core default bold */,
  CARD: { url: './assets/fonts/Pragmatic-Suits.woff2', priority: 'block', kind: 'font' } /* core cards */,
  CHIP: { url: './assets/fonts/Montserrat-Chip.woff2', priority: 'block', kind: 'font' } /* core chips */,
};
